import React from 'react';
import { Provider } from 'react-redux';

import Pages from './pages';

const Root = ({store, history}) => (
	<Provider store={store}>
		<Pages history={history}/>
	</Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/root.js